/**
 * Constants
 */

const STATUS = {
  COMPLETE: 'STATUS_COMPLETE',
  PROCESS: 'STATUS_PROCESS',
  WAIT: 'STATUS_WAIT',
};

export default STATUS;



// WEBPACK FOOTER //
// ./src/components/Steps/constants.js